import React from 'react';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import { InputLabel, Radio, RadioGroup, FormHelperText, FormControlLabel } from '@mui/material';
import classnames from 'classnames';

export class RadioInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this)
  }

  handleOnChange(event, value){
    this.props.onChange(value)
  }

  render() {
    const { name, label, options, row, containerClass, hint, value, errorMessage, isPristine, onChange } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className={classnames('input-container', containerClass)}>
        <InputLabel htmlFor={name} error={isError}>{label}</InputLabel>
        <RadioGroup
          id={name}
          row={row}
          name={name}
          onChange={this.handleOnChange}
          value={value || ""}
        >
          {options.map((option, i) => (
            _.isString(option) ?
              <FormControlLabel key={i} value={option} control={<Radio />} label={option} />
            :
              <FormControlLabel key={i} value={option.value} control={<Radio />} label={option.label} />
          ))}
        </RadioGroup>
        {!isPristine && errorMessage &&
          <FormHelperText error={isError} className="input-error">{errorMessage}</FormHelperText>
        }
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(RadioInput);
